export const WALK_THROUGH_1_CONSTANTS = {
  WALK_THROUGH_FIELDS_CONFIG: [
    {
      fieldName: "desktop_bg_image",
      label: "Desktop Background Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload desktop background image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_bg_image",
      label: "Mobile Background Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload mobile background image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "alt_image",
      label: "Background image alt text",
      value: "Campus walkthrough",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Alt text for accessibility",
      required: false,
      defaultValue: "Campus walkthrough",
    },
    {
      fieldName: "title_prefix",
      label: "Main headline",
      value: "IIT Kharagpur marks 75 Years of Academic Excellence and Leadership",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Primary headline text",
      required: false,
      defaultValue:
        "IIT Kharagpur marks 75 Years of Academic Excellence and Leadership",
    },
    {
      fieldName: "title_highlight",
      label: "Title — highlighted phrase (optional)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Optional middle phrase (uses highlight color)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "title_suffix",
      label: "Title — suffix (optional)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Optional text after highlight",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "title_highlight_color",
      label: "Highlighted phrase color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Color for highlighted phrase",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "video_link",
      label: "Video URL (YouTube or direct)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Paste video URL",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "cta_label",
      label: "Button label",
      value: "View Video",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "View Video",
      required: false,
      defaultValue: "View Video",
    },
    {
      fieldName: "cta_bg_color",
      label: "Button background color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "View Video button background",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "cta_text_color",
      label: "Button text color",
      value: "#171719",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "View Video button text",
      required: false,
      defaultValue: "#171719",
    },
    {
      fieldName: "overlay_color",
      label: "Overlay color",
      value: "#352D59",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Scrim over the image",
      required: false,
      defaultValue: "#352D59",
    },
    {
      fieldName: "overlay_opacity",
      label: "Overlay opacity",
      value: 0.9,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "0–1 (e.g. 0.9)",
      required: false,
      defaultValue: 0.9,
    },
    {
      fieldName: "status",
      label: "Section Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Section",
      defaultValue: true,
    },
  ],
};
